import { render, staticRenderFns } from "./ArtiklEdit.vue?vue&type=template&id=77637c6e&scoped=true"
import script from "./ArtiklEdit.vue?vue&type=script&lang=js"
export * from "./ArtiklEdit.vue?vue&type=script&lang=js"
import style0 from "./ArtiklEdit.vue?vue&type=style&index=0&id=77637c6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77637c6e",
  null
  
)

export default component.exports